import { Currency } from 'constants/common';
import Dollar from './dollar';
import Euro from './euro';

const currencyMapping = {
  [Currency.CAD]: Dollar,
  [Currency.USD]: Dollar,
  [Currency.EUR]: Euro,
  default: Dollar,
} as const;

export default currencyMapping;
